import { HttpClient } from '@angular/common/http';
import { inject } from '@angular/core';
import { LanguageService } from '@core/services/language/language.service';
import { mergeDeep, TranslateLoader, TranslationObject } from '@ngx-translate/core';
import { Settings } from 'luxon';
import { forkJoin, Observable, of } from 'rxjs';
import { catchError, map, take } from 'rxjs/operators';

const translationFiles = [
  'core',
  'auth',
  'shared',
  'menus',
  'customers',
  'report',
  'search',
  'ged',
  'settings',
  'virtual-printer',
  'virtual-printer-new',
  'gdbd',
  'validator',
  'validations',
  'archives',
  'sso',
  'tracking',
  'control',
  'verify-sign',
  'announcements',
];

export class CustomTranslateLoader implements TranslateLoader {
  private readonly http = inject(HttpClient);
  private readonly prefix = './assets/i18n/';
  private readonly suffix = '.json';

  public getTranslation(lang: string): Observable<TranslationObject> {
    Settings.defaultLocale = lang;
    const requests = translationFiles.map((file) => {
      const url = `${this.prefix}${lang}/${file}-${lang}${this.suffix}`;
      return this.http.get(url).pipe(catchError(() => of({})));
    });
    return forkJoin(requests).pipe(
      take(1),
      map((trads) => trads.reduce((allTrads, trad) => mergeDeep(allTrads, trad), {})),
    );
  }
}

export function translateInitializerFactory(languageService: LanguageService) {
  return languageService.initTranslation();
}
